package org.zq.flvtomp4

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.tooling.preview.Preview
import org.zq.flvtomp4.screen.MainScreen
import org.zq.flvtomp4.ui.theme.AppTheme
import org.zq.flvtomp4.viewmodel.MainViewModel

@Composable
@Preview
fun App() {
    AppTheme {
        val viewModel = remember { MainViewModel() }
        MainScreen(viewModel)
    }
}
